import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import HipobuySpreadsheetGuide from "@/pages/hipobuy-spreadsheet-guide/page";
import HipobuySpreadsheetSafety from "@/pages/hipobuy-spreadsheet-safety/page";
import HipobuySpreadsheetAlternatives from "@/pages/hipobuy-spreadsheet-alternatives/page";
import HipobuySpreadsheetTutorial from "@/pages/hipobuy-spreadsheet-tutorial/page";
import HipobuySpreadsheetReview from "@/pages/hipobuy-spreadsheet-review/page";
import HipobuySpreadsheetBeginnerMistakes from "@/pages/hipobuy-spreadsheet-beginner-mistakes/page";
import HipobuySpreadsheetCategories from "@/pages/hipobuy-spreadsheet-categories/page";
import BestSpreadsheetResources from "@/pages/best-spreadsheet-resources/page";
import KakobuySpreadsheet from "@/pages/kakobuy-spreadsheet/page";
import CssbuySpreadsheet from "@/pages/cssbuy-spreadsheet/page";
import SuperbuySpreadsheet from "@/pages/superbuy-spreadsheet/page";
import OopbuySpreadsheet from "@/pages/oopbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <HipobuySpreadsheetGuide />,
  },
  {
    path: "/hipobuy-spreadsheet-safety",
    element: <HipobuySpreadsheetSafety />,
  },
  {
    path: "/hipobuy-spreadsheet-alternatives",
    element: <HipobuySpreadsheetAlternatives />,
  },
  {
    path: "/hipobuy-spreadsheet-tutorial",
    element: <HipobuySpreadsheetTutorial />,
  },
  {
    path: "/hipobuy-spreadsheet-review",
    element: <HipobuySpreadsheetReview />,
  },
  {
    path: "/hipobuy-spreadsheet-beginner-mistakes",
    element: <HipobuySpreadsheetBeginnerMistakes />,
  },
  {
    path: "/hipobuy-spreadsheet-categories",
    element: <HipobuySpreadsheetCategories />,
  },
  {
    path: "/best-spreadsheet-resources",
    element: <BestSpreadsheetResources />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuySpreadsheet />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CssbuySpreadsheet />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuySpreadsheet />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuySpreadsheet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;